<template>
	<div id="report-modal">
		<Modal @close="closeModal" :draggable="false" :modalWidth="modalWidth" v-show="modalShow">
			<template slot="title">Report</template>
			<template slot="body">
				<div class="renderArea" id="renderArea"></div>
			</template>
		</Modal>
		<Modal @close="closeMailModal" :draggable="false" v-show="mailModal">
			<template slot="title">Mail</template>
			<template slot="body">
				<div style="width: 800px; height: 550px;">
					<input type="hidden" name="send_address" />
					<input type="hidden" name="send_name" />
					<div>
						<div class="mail_top_box">
							<div class="mail_user">
								<dl>
									<dt>Send Address</dt>
									<!-- ZD-3331 : 등록된 발신 주소가 2개 이상이면 선택 -->
									<dd v-if="send_address_list.length > 1">
										<select class="tbl_select" v-model="mail.sendAddress">
											<option v-for="address in send_address_list" :key="address" :value="address">{{ address }}</option>
										</select>
									</dd>
									<dd v-else>{{ mail.sendAddress }}</dd>
								</dl>
							</div>
							<div class="mail_user">
								<dl>
									<dt class="mail_name_dt">Send Name</dt>
									<dd>{{ mail.sendName }}</dd>
								</dl>
							</div>
						</div>

						<AddressWrap :title="'Mail Address'" :type="'to'" :address-list="mail.toList" @input="addAddress" @click="deleteAddress" />

						<AddressWrap :title="'CC'" :type="'cc'" :address-list="mail.ccList" @input="addAddress" @click="deleteAddress" />

						<AddressWrap :title="'BCC'" :type="'bcc'" :address-list="mail.bccList" @input="addAddress" @click="deleteAddress" />

						<div class="mail_contents">
							<div class="mc_int_box">
								<span class="mail_address_text">Subject</span>
								<p>
									<label>
										<input type="search" class="tbl_int" placeholder="" v-model="mail.subject" />
									</label>
								</p>
								<div class="mc_textarea">
									<label>
										<textarea rows="7" name="content" v-model="mail.content"></textarea>
									</label>
								</div>
							</div>
							<div class="mc_int_box">
								<span class="mail_address_text">Attachment</span>
								<p class="int_file_p">
									<input type="file" multiple @change="previewFiles" ref="files" />
								</p>
								<div class="attact_file_box">
									<ul>
										<li v-for="(value, index) in mail.fileNames" :key="index">
											<em>{{ value }}</em>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="popup_bottom">
					<a href="javascript:void(0);" class="normal_bt" @click="sendMail">Send & Close</a>
					<a href="javascript:void(0);" class="gray_bt" @click="closeMailModal">Cancel</a>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from '@/components/common/Modal';
import AddressWrap from '@/components/common/AddressWrap';
import { createReport, createReportBase64, createReportFile, PrintType } from '@/api/util';
import { apiMail } from '@/api/mail/mail';
import { apiSelectCompany } from '@/api/company';
import { apiSelectSystemSettingsBykeyArr } from '@/api/basicinfo/systemsetting.js';
import { emailRegExp } from '@/utils/etc.js';
import { buildSendAddressList, pickDefaultSendAddress } from '@/utils/mailUtils.js';

export default {
	data: function() {
		return {
			modalShow: false,
			mailModal: false,
			mail: {
				sendAddress: '',
				sendName: '',
				subject: '',
				content: '',
				toList: [],
				bccList: [],
				ccList: [],
				fileNames: [],
				files: '',
				fileName: '',
				fileBlob: '',
				division: '',
				source: 'PC',
			},
			// ZD-3331 : 발신 주소 후보. mail 밖에 둬서 메일 요청(FormData)에 실리지 않게 한다.
			send_address_list: [],
			company: '',
			reportFile: '',
			report: '',
			modalWidth: 0,
		};
	},
	computed: {
		storeShow: function() {
			return this.$store.getters.getShowModal;
		},
	},
	components: {
		AddressWrap,
		Modal,
	},
	methods: {
		closeModal() {
			this.modalShow = false;
			this.$store.commit('setShowModal', false);
		},
		keyUpESC(e) {
			if (e.keyCode === 27) this.closeModal();
		},
		closeMailModal() {
			this.mailModal = false;
			this.mailClean();
		},
		addAddress(type, address) {
			if (type === 'to') this.mail.toList.push(address);
			else if (type === 'cc') this.mail.ccList.push(address);
			else if (type === 'bcc') this.mail.bccList.push(address);
		},
		previewFiles(event) {
			const fileList = event.target.files;
			this.mail.fileNames = [];
			this.mail.fileNames.push(this.mail.fileName);

			let files = [];

			for (const file of this.$refs.files.files) {
				files.push(file);
			}

			this.mail.files = this.$refs.files.files;

			for (const file of fileList) {
				this.mail.fileNames.push(file.name);
			}
		},
		deleteAddress(type, index) {
			if (type === 'to') this.mail.toList.splice(index, 1);
			else if (type === 'cc') this.mail.ccList.splice(index, 1);
			else if (type === 'bcc') this.mail.bccList.splice(index, 1);
		},
		mailClean() {
			this.send_address_list = [];
			this.mail.sendAddress = '';
			this.mail.sendName = '';
			this.mail.subject = '';
			this.mail.content = '';
			this.mail.toList = [];
			this.mail.bccList = [];
			this.mail.ccList = [];
			this.mail.fileNames = [];
			this.mail.files = '';
			this.mail.fileName = '';
			this.mail.fileBlob = '';
			this.mail.division = '';
			this.mail.source = 'PC';
		},
		getOption() {
			let options = new window.Stimulsoft.Viewer.StiViewerOptions();
			options.appearance.scrollbarsMode = true;
			options.appearance.fullScreenMode = false;
			options.height = '100%';
			options.toolbar.showOpenButton = false;
			options.toolbar.printDestination = window.Stimulsoft.Viewer.StiPrintDestination.Pdf;
			options.toolbar.viewMode = window.Stimulsoft.Viewer.StiWebViewMode.Continuous;
			return options;
		},
		async sendMail() {
			const valid_to = this.mail.toList.filter(e => e && e.trim());
			if (valid_to.length === 0) {
				this.$toast.error('Please add at least one recipient.');
				return;
			}
			const invalid_email = valid_to.find(e => !emailRegExp(e.trim()));
			if (invalid_email) {
				this.$toast.error(`Invalid email address: ${invalid_email.trim()}`);
				return;
			}

			this.mail.content = this.mail.content.replace('\n', '<br>');

			const { data } = await apiMail(this.mail);

			if (data.result_code === 'success') {
				this.$toast.success('Send Mail is Complete.');
				this.closeMailModal();
				//this.closeModal();
			} else {
				this.$toast.error('error');
			}
		},
		async selectCompany() {
			const { data } = await apiSelectCompany();
			this.company = data.company;
		},
		async createReportList(reportTemplate, dataList, base64) {
			let reportMerge = new window.Stimulsoft.Report.StiReport();
			if (base64) {
				reportMerge.reportUnit = createReportBase64(reportTemplate, '').reportUnit;
			} else {
				reportMerge.reportUnit = createReport(reportTemplate).reportUnit;
			}

			reportMerge.render();
			reportMerge.renderedPages.clear();
			reportMerge.dictionary.databases.clear();
			for (const data of dataList) {
				let template;
				if (base64) {
					template = createReportBase64(reportTemplate, '');
				} else {
					template = createReport(reportTemplate);
				}

				await this.reportListMerge(template, data, reportMerge);
			}
			return reportMerge;
		},
		reportListMerge(reportTemplate, data, reportMerge) {
			return new Promise(resolve => {
				let dataSet = new window.Stimulsoft.System.Data.DataSet();
				dataSet.readJson(data);
				reportTemplate.regData('', '', dataSet);
				reportTemplate.renderAsync(function() {
					for (let index = 0; index < reportTemplate.renderedPages.count; ++index) {
						const page = reportTemplate.renderedPages.getByIndex(index);
						reportMerge.renderedPages.add(page);
					}
					resolve(1);
				});
			});
		},
		async setAWSEmailAddress() {
			const { data } = await apiSelectSystemSettingsBykeyArr(['email_address', 'email_address_extra']);
			let idx = data.findIndex(el => el.setting_key === 'email_address');
			this.mail.sendAddress = idx > -1 ? data[idx].setting_value : null;

			// ZD-3331 : 등록된 발신 주소가 2개 이상이면 목록에서 고른다. 1개 이하면 위의 기존 동작 그대로다.
			// 2차 : 기본 선택값은 로그인 사용자 Email 이 등록 주소면 그 주소, 아니면 기본 주소(첫 후보)다.
			//       사용자 Email 은 로그인 때 세션에 들어가므로 바꾼 뒤에는 다시 로그인해야 반영된다.
			const extra = data.find(el => el.setting_key === 'email_address_extra');
			const address_list = buildSendAddressList(this.mail.sendAddress, extra ? extra.setting_value : null);
			this.send_address_list = address_list.length > 1 ? address_list : [];
			if (this.send_address_list.length > 1) {
				const user = this.$session ? this.$session.get('user') : null;
				this.mail.sendAddress = pickDefaultSendAddress(this.send_address_list, user ? user.email : null);
			}
		},
		async mailSetting() {
			const vm = this;
			//회사 이름, 메일 설정
			this.mail.sendName = this.company.name;
			// this.mail.sendAddress = this.company.mail;
			await this.setAWSEmailAddress();

			//파일 이름, 메일 타입 설정
			this.mail.fileName = this.report.fileName + '.pdf';
			this.mail.division = this.report.reportTemplate.reportName;
			this.mail.subject = this.report.fileName;

			// cc list 추가
			if (this.report.toList && this.mail.toList.length === 0) this.report.toList.forEach(value => vm.addAddress('to', value));

			if (this.mail.fileNames.length === 0) this.mail.fileNames.push(this.mail.fileName);
			// this.mail.fileBlob = this.reportFile;

			// content에 회사정보 추가
			if (this.company.company_id === 'hairplus') {
				this.mail.content =
					'\n\n' +
					(this.company.name_information || this.company.name) +
					'\nWholesaler. Importer. Exporter\n' +
					(this.company.address_detail || '') +
					', ' +
					(this.company.address_city || '') +
					', ' +
					(this.company.address_state || '') +
					' ' +
					(this.company.address_zipcode || '') +
					'\nTel: ' +
					(this.company.phone_no || '') +
					'\tFax: ' +
					(this.company.fax_no || '') +
					'\n' +
					(this.company.url || '') +
					(this.company.company_id === 'hairplus' ? '\nACCOUNT MANAGER IRIS KIM / IRIS@FEMICOLLECTION.COM  & THANK YOU !!' : '');
			}

			this.mailModal = true;
		},
	},
	watch: {
		async storeShow(modal) {
			if (modal) {
				await this.selectCompany();

				this.report = this.$store.getters.getReport;
				this.modalWidth = this.report.modalWidth;
				const reportData = this.report.data;
				if (reportData.invoice && reportData.invoice.courier_type && reportData.invoice.track_no) {
					if (reportData.invoice.courier_type === 'U') {
						this.mail.content =
							'\n<br><br><a href="https://wwwapps.ups.com/WebTracking/processRequest?HTMLVersion=5.0&Requester=NES&AgreeToTermsAndConditions=yes&loc=en_US&tracknum=' +
							reportData.invoice.track_no +
							'&WT.z_eCTAid=ct1_eml_Tracking/trackdetails">Shipping Information</a>';
					} else if (reportData.invoice.courier_type === 'F') {
						this.mail.content = '\n<br><br><a href="https://www.fedex.com/fedextrack/?trknbr=' + reportData.invoice.track_no + '">Shipping Information</a>';
					}
				}
				if (reportData.invoice && this.company.company_id === 'newjigu') {
					this.mail.content = 'Thank you for your order. Please find attached your shipment invoice.\nIf you have any questions please reach out to us.\n' + this.mail.content;
				}

				const reportTemplate = this.report.reportTemplate;
				const type = this.report.type;
				const mailModalOpen = this.report.mailModalOpen;
				const options = this.getOption();
				const fileName = this.report.fileName;
				let viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
				reportTemplate.reportAlias = fileName;
				/*
				// print 콜백 테스트
				console.log(viewer);
				viewer.onPrintReport = event => {
					console.log('onPrintReport');
					console.log(event);
					this.closeModal();
				};

				viewer.jsObject.postPrint('PrintWithoutPreview');
*/
				//				await this.selectCompany();

				if (type === PrintType.List) {
					viewer.report = await this.createReportList(reportTemplate, reportData, this.report.base64);
					viewer.renderHtml('renderArea');
				} else {
					if (reportData) {
						let dataSet = new window.Stimulsoft.System.Data.DataSet();
						dataSet.readJson(reportData);
						reportTemplate.regData('', '', dataSet);
					}
					viewer.report = reportTemplate;
					viewer.renderHtml('renderArea');
				}

				let userButton = viewer.jsObject.SmallButton('userButton', 'Send Email', 'SendEmail.png');

				const vm = this;

				let action = function() {
					vm.mailSetting();
					const report = type === PrintType.List ? viewer.report : reportTemplate;
					createReportFile(report).then(base64Blob => {
						vm.mail.fileBlob = base64Blob;
					});
				};
				userButton.action = action;
				// this.reportFile = createReportFile(reportTemplate);
				const toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
				const buttonsTable = toolbarTable.rows[0].firstChild.firstChild;
				const userButtonCell = buttonsTable.rows[0].insertCell(2);
				userButtonCell.className = 'stiJsViewerClearAllStyles';
				userButtonCell.appendChild(userButton);

				this.modalShow = true;
				if (mailModalOpen) {
					viewer.onShowReport = action;
				}

				window.addEventListener('keyup', this.keyUpESC);
			} else {
				window.removeEventListener('keyup', this.keyUpESC);
			}
		},
	},
};
</script>
